export enum ModalStates {
  open = 'OPEN',
  close = 'CLOSE',
  delete = 'DELETE',
}

export enum FormBuilderVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export enum FormTypes {
  INTERACTIVE_FORM = 'Interactive form',
  LMS_FORM = 'LMS form',
  SCORM_FORM = 'SCORM form',
}

export enum FormSubmissionStatusType {
  INITIAL = 'initial',
  PENDING = 'pending',
  MARKS_SUBMITTED = 'marks-submitted',
  REQUEST_RESUBMIT = 'request-resubmit',
}

export enum FormSubmissionStatusSubType {
  INITIAL = 'initial',
  FORM_PENDING = 'pending',
  FORM_MARK_SUBMITTED = 'marks-submitted',
  FORM_REQUEST_RESUBMIT = 'request-resubmit',
}

export enum FormSubmissionSetting {
  BEFORE = 'before',
  AFTER = 'after',
  UNDEFINED = 'undefined',
}

export enum FormCreationRedierctFrom {
  ASSIGN_FORMS = 'assignForm',
}

export interface ISaveFormModalForm {
  id?: string;
  formType: string;
  formTitle: string;
  formDescription: string;
  fileName: string;
  scormFileUrl: string;
  marksEnabled: boolean;
  displayMarksUntilMarkingComplete: boolean;
  passMark: number;
  badgeImgUrl: string;
  badgeTitle: string;
  version: FormBuilderVersion,
  badgeDescription: string;
  resolve?: any;
  reject?: any;
}

export interface IFormDocument {
  _id: string;
  formType: string;
  marksEnabled: boolean;
  displayMarksUntilMarkingComplete: boolean;
  passMark: number;
  badgeImgUrl: string;
  version: FormBuilderVersion;
  badgeTitle: string;
  badgeDescription: string;
  formTitle: string;
  formDescription: string;
  fileName: string;
  scormFileUrl: string;
  availability: string;
  formConfig: string;
  answerData: string;
  createdAt: string;
  updatedAt: string;
}

export interface IForm extends IFormDocument {
  modalState: string;
  meta: {
    apiStatus: {
      message: string;
      status: string;
    }
  }
}

export interface IDeleteForm {
  id: string;
  bannerImgUrl: string;
}

export interface IOpenModal {
  id: string;
  state: string;
}

export interface IFilteredForms {
  total: number;
  result: IForm[];
}
export interface ViewFormsState {
  stateLoading: boolean;
  loading: boolean;
  filteredForms: IFilteredForms;
  formSettings: ISaveFormModalForm;
  formId: string;
  formConfig: string;
  version: FormBuilderVersion;
  answerData: string;
  modal: ModalStates;
  userSessionId: string;
  userModuleCompletionId: string;
  status: string;
  createStatus: number;
  creationRedirectFrom: string;
  createdAt: string,
  updatedAt: string,
  formConfigModal: ModalStates;
}

export interface IFormFilterPayload {
  keyword: string;
  page: number;
  limit: number;
  sortBy: string;
  formType: string;
  availability?: string;
}

export interface IFormFilterStateAction {
  payload: IFormFilterPayload;
  type: string;
}

export interface ICreateFormModalStateAction {
  payload: string;
  type: string;
}

export interface IDeleteFormAction {
  payload: IDeleteForm;
  type: string;
}

export interface ISaveScormFormModalFormAction {
  payload: ISaveFormModalForm;
  type: any;
}

export interface ISubmittedFormResponse {
  _id: string;
  form: IFormDocument;
  data: string;
  status: string;
  createdAt: string,
  updatedAt: string,
}

export interface ISubmittedFormStateAction {
  payload: ISubmittedFormResponse;
  type: string;
}

export enum FormAvailabilityType {
  PROCESSING = 'Processing',
  READY = 'Ready to use',
  UNAVAILABLE = 'Unavailable',
}
